const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
//const Backofficebff: any = "/api/v1";

export const GreetingNotesCommand: any = {
    CreateGreetingNotes: Backofficebff + '/v1/greetingnotes/create-greeting-notes',
    UpdateGreetingNotes: Backofficebff + '/v1/greetingnotes/update-greeting-notes',
};
